module.exports = __webpack_public_path__ + "static/media/jamelah.5408fefa.svg";